import isNonBrowserRenderableImageMime from './isNonBrowserRenderableImageMime';

function hasRasterThumbnailUrl(asset) {
  const t = asset && asset.thumbnail;
  if (!t || typeof t !== 'object') return false;
  return Boolean(t.big || t.default || t.small);
}

/**
 * Decide whether the Copy / Download dialog can render the source image
 * inside an interactive crop preview.
 *
 * We can show the crop preview when at least one of the following is true:
 *  1. the source format is natively renderable in a browser <img> (JPG, PNG,
 *     WebP, GIF, SVG, BMP and similar); OR
 *  2. the format is NOT natively renderable (HEIC/HEIF, TIFF, any RAW, PSD,
 *     AI, EPS …) but the asset has a raster thumbnail URL we can fall back
 *     to — the same fallback the crop preview component already uses.
 *
 * When neither is true (e.g. a freshly imported AI whose thumbnail has not
 * yet been generated, or a very old asset with a lost thumbnail) we cannot
 * render any useful preview, and the dialog should keep the format /
 * quality / resize controls but hide the crop preview and crop parameters.
 *
 * @param {Object|null|undefined} asset - extended catalog asset
 * @returns {boolean}
 */
export default function canShowCropPreview(asset) {
  if (!asset) return false;

  const { mimeType } = asset;
  const { fileExtension } = asset;

  if (!isNonBrowserRenderableImageMime(mimeType, fileExtension)) return true;

  return hasRasterThumbnailUrl(asset);
}
